// Eastwick, Waterfront, Milkyway, Violin, Paros, Abbey
const carouselMatchingCardData = [
  {
    link: '/wedding-planning/save-the-date/5b158084c268e90ab45b7a70',
    imgName: 'heaven',
    imgAlt: 'Heaven',
  },
  {
    link: '/wedding-planning/save-the-date/5b158079c268e90ab45b71a8',
    imgName: 'abbey',
    imgAlt: 'Abbey',
  },
  {
    link: '/wedding-planning/save-the-date/5b158080c268e90ab45b76cc',
    imgName: 'cruise',
    imgAlt: 'Cruise',
  },
  {
    link: '/wedding-planning/save-the-date/5b158089c268e90ab45b7f88',
    imgName: 'clemson',
    imgAlt: 'Clemson',
  },
  {
    link: '/wedding-planning/save-the-date/5b158084c268e90ab45b7a8c',
    imgName: 'napa',
    imgAlt: 'Napa',
  },
  {
    link: '/wedding-planning/save-the-date/5b15807cc268e90ab45b73cc',
    imgName: 'violin',
    imgAlt: 'Violin',
  },
];

export default carouselMatchingCardData;



// WEBPACK FOOTER //
// ./src/components/common/MatchingCardCarousel/carouselMatchingCardData.js